/** Routing is tab-local; API paths and static asset paths remain unchanged. */
const segment = location.pathname.split("/").filter(Boolean)[0] ?? "";
export const bookingBasePath =
  segment === "booking" ? "/booking" : `/${segment}`;
export function inBookingPath(path: string): boolean {
  return path === bookingBasePath || path.startsWith(`${bookingBasePath}/`);
}
export function bookingRelativePath(path: string): string {
  return inBookingPath(path)
    ? path.slice(bookingBasePath.length).replace(/^\//, "")
    : "";
}
export const routingProfile =
  segment === "booking"
    ? import.meta.env.VITE_BOOKING_PROFILE_SLUG || "michal"
    : segment;
export const bookingDraftKey = `booking-draft-v2:${location.origin}:${bookingBasePath}`;
